import { memo, useContext } from "react";
import "./SmartDPHotelDescriptionLoader.scss";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";
import appGlobalsContext from "app/AppGlobalsContext";

const SmartDPHotelDescriptionLoader = () => {
	const { publicPath = "" } = useContext(appGlobalsContext);
	return (
		<div className="sdp-hotel-description-loader">
			<div className="sdp-hotel-description-loader__header">
				<LoaderBar />
				<LoaderBar />
			</div>
			<img
				className="sdp-hotel-description-loader__photo"
				src={`${publicPath}/icons/quote_img.png`}
			/>
			<img src={`${publicPath}/icons/quote_description.svg`} />
		</div>
	);
};

export default memo(SmartDPHotelDescriptionLoader);
